module.exports = __webpack_public_path__ + "static/img_link_card_03@2x-d1fdfc6f374ab91824414b71d2d30644.png";